export const COGNITO_USER_POOL_ID = 'COGNITO_USER_POOL_ID';
export const COGNITO_CLIENT_ID = 'COGNITO_CLIENT_ID';
export const COGNITO_DOMAIN = 'COGNITO_DOMAIN';
export const COGNITO_CALLBACK_URL = 'COGNITO_CALLBACK_URL'
const getEnvVarValue = (envVarName) => {
  let variablePrefix = 'REACT_APP_PROD_CPMT_';
  if (window.location.hostname.startsWith(process.env.REACT_APP_LOCAL_ENV)) {
    variablePrefix = 'REACT_APP_DEV_CPMT_';
  }
  if (window.location.hostname.startsWith(process.env.REACT_APP_DEV_ENV)) {
    variablePrefix = 'REACT_APP_DEV_CPMT_';
  }
  if (window.location.hostname.startsWith(process.env.REACT_APP_TEST_ENV)) {
    variablePrefix = 'REACT_APP_TEST_CPMT_';
  }
  if (window.location.hostname.startsWith(process.env.REACT_APP_LOCAL_ENV) && envVarName === COGNITO_CALLBACK_URL) {
    variablePrefix = 'REACT_APP_LOCAL_CPMT_';
  }
  const variableName = `${variablePrefix}${envVarName}`;
  return process.env[variableName];
};
export default getEnvVarValue;

